import { PF_PAGE_VIEW_MAP, PF_CATEGORY_MAP } from './tracking.map';

export const getPageView = ({ page, customPage }) =>
  PF_PAGE_VIEW_MAP[page] || PF_PAGE_VIEW_MAP[customPage] || customPage;

export const getCategoryPage = ({ page, customPage }) =>
  PF_CATEGORY_MAP[page] || PF_CATEGORY_MAP[customPage] || customPage;

export const replaceDeposit = (label, deposit) => {
  const depositAmountTracking = Math.round(deposit?.amount) || 'na';
  return label.includes('_dep:Z')
    ? label.replace('_dep:Z', `_dep:${depositAmountTracking}`)
    : label;
};
